import styled from "styled-components";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";
import {
    BLACKJACK_PAGE,
    CASINO_GAMES_PAGE,
    ROULETTE_PAGE, SCRATCH_CARDS_PAGE,
    SLOTS_PAGE,
    VIDEO_POKER_PAGE
} from "../../../themes/css-global-classes";

export const RouterOutletCasino888Box = styled(RouterOutletDefaultBox)`
    background-image: url("${props => props.theme.images.texture.toString()}");

    .${SLOTS_PAGE} & {
        background: radial-gradient(ellipse at center, #232323 0%, #000000 100%);
    }

    .${CASINO_GAMES_PAGE} & {
        background: radial-gradient(ellipse at center, #001b01 0%, #001000 100%);
    }

    .${VIDEO_POKER_PAGE} & {
        background: radial-gradient(ellipse at center, #000E24 0%, #000000 100%);
    }

    .${ROULETTE_PAGE} &, .${BLACKJACK_PAGE} & {
        background: radial-gradient(ellipse at center, #071A01 0%, #000000 100%);
    }

    .${SCRATCH_CARDS_PAGE} & {
        background: radial-gradient(ellipse at center, #12011A 0%, #000000 100%);
    }
`